import { isStatusInProgress, isStatusNotStarted } from '../../../utils/statusUtils';
import { isMilestoneNode } from '../../../utils/milestoneUtils';
import {
  isNestedSprintCompleted,
  isNestedSprintInProgress,
  isTaskBlocked,
} from '../../../../shared/utils/taskAvailabilityUtils';

/**
 * Shared mission grouping for Flowchart HUD and Neural view (same rules as Flow).
 * Milestones are flow-only markers — never shown in active/available mission lists.
 */
export function computeMissionHudLists(
  tasks,
  statuses,
  lockStates = {},
  nestedSprints = [],
  allSprints = [],
) {
  const missionTasks = (tasks || []).filter((task) => !isMilestoneNode(task) && task.nodeType !== 'note');

  const activeTasks = missionTasks.filter((task) => {
    if (isNestedSprintCompleted(task, nestedSprints)) return false;
    if (isTaskBlocked(task, nestedSprints, statuses, allSprints)) return false;
    if (isNestedSprintInProgress(task, nestedSprints, statuses, allSprints)) return true;
    return isStatusInProgress(task.status, statuses);
  });

  const blockedTasks = missionTasks.filter((task) => {
    if (isNestedSprintCompleted(task, nestedSprints)) return false;
    return isTaskBlocked(task, nestedSprints, statuses, allSprints);
  });

  const availableTasks = missionTasks.filter((task) => {
    if (isNestedSprintCompleted(task, nestedSprints)) return false;
    if (isNestedSprintInProgress(task, nestedSprints, statuses, allSprints)) return false;
    if (isTaskBlocked(task, nestedSprints, statuses, allSprints)) return false;
    const isLocked = lockStates[task.id]?.isLocked;
    if (isLocked) return false;
    if (!isStatusNotStarted(task.status, statuses)) return false;
    if (task.nodeType === 'decision' && task.answer) return false;
    return true;
  });

  const waitingTasks = missionTasks
    .filter((task) => {
      if (isNestedSprintCompleted(task, nestedSprints)) return false;
      if (isTaskBlocked(task, nestedSprints, statuses, allSprints)) return false;
      const ls = lockStates[task.id];
      if (!ls?.isLocked) return false;
      const blockers = ls.blockingTasks || [];
      const waiting = blockers.some((t) => t.reason === 'waiting_until');
      const people = blockers.some((t) => t.reason !== 'waiting_until');
      return waiting && !people;
    })
    .map((task) => ({
      ...task,
      blockedReason: lockStates[task.id]?.lockReason || 'Available soon',
      _isWaiting: true,
    }));

  return { activeTasks, blockedTasks, availableTasks, waitingTasks };
}
